const searchFieldEraser = () => {
    const eraser = document.querySelector('.Search-field__eraser');
    const input = document.querySelector('.Search-field__input');

    if (input && eraser) {
        input.addEventListener('input', () => {
            const inputValue = input.value;
            if (inputValue.length > 0) {
                eraser.classList.add('--Is-active');
            } else {
                eraser.classList.remove('--Is-active');
            }
        });

        eraser.addEventListener('click', (e) => {
            e.preventDefault();
            input.value = '';
            eraser.classList.remove('--Is-active');
        });
    }

    const closeBtn = document.querySelector('.Search-field__close-btn');

    if (closeBtn) {
        closeBtn.addEventListener('click', (e) => {
            e.preventDefault();
            input.value = '';
            eraser.classList.remove('--Is-active');
        });
    }
};

export default searchFieldEraser;
